//配置相关
export default {
  debug: false, //开发者模式 不定义或者false表示正式模式
  //强制显式DN(商户)在url 如果url上没带dn参数的话就直接报错 需要管理端在生成链接时考虑是否加入dn在url
  forceExplicitDN: false,
  //token有效期
  tokenExpire: 7200,
  //请求的url
  apiUrl: {
    dev: '/api',
    // dev: 'http://hym.bakepro.cn/api',
    // pro: 'http://hym.bakepro.cn/api' // 测试环境
    //_test pro: 'http://test.wap.scrm.huangyebl.com/api' //生产环境
    pro: 'https://api.scrm.huangyebl.com/api' //生产环境
  },
  //linkUrl: 'hym.bakepro.cn', // 测试环境
  linkUrl: 'wap.scrm.huangyebl.com', // 生产环境
  //请求白名单 无需常规token
  apiWhite: [
    '/wap/User/auhorizeurl',
    '/wap/User/login', //需要特殊token
    '/wap/User/debuglogin', //需要特殊token
    '/wap/User/signup' //需要特殊token
  ],
  //无需绑定手机号即可请求的接口(需要正常业务的token)
  anonymousApi: [
    '/wap/Account/NewUserSms', //发送绑定手机号验证码
    '/wap/User/Rules', //注册页面开卡策略的获取
  ],

  //不需要设置默认分享设置的路径 如 '/Member/Pay',不包含参数部分
  //这里排除 开发者可以自行在组件内进行 wx.updateAppMessageShareData({}) 类似的自定义调用
  //这里无效 VUE使用的是单页面进入其他页面会导致排除页面也会出现分享
  wxSdkEliminatePath: [
    //'/Member/Pay'
  ],

  //微信授权类型
  wechatScopBase: 'snsapi_base',
  wechatScopInfo: 'snsapi_userinfo',
  //token缓存名
  tokenName: '__USER_TOKEN__',
  // 微信获取用户基本信息
  weixinInfo_name: '__USER_INFO_NAME__',
  weixinInfo_img: '__USER_INFO_IMG__',
  weixinInfo_mobile: '__USER_INFO_MOBILE__',
  mp: '__USER_MP__',
  setPwd: '__SET_PWD__',
  tenant: '__SET_TENANT__',
  // member: '__IS_MEMBER__',
  //生成oauth链接 接口返回的token(用于登录)
  loginTokenName: '__USER_LOGIN_TOKEN__',
  //请求登录接口 如果未注册 返回的token(用户注册)
  registerTokenName: '__USER_REGISTER_TOKEN__',
  //未注册用户使用正常业务时候需要的token （如 发送注册验证码）
  anonymousTokenName: '__USER_ANONYMOUS_TOKEN__',
  //注册请求所需的基础数据 openid、nickname等
  registerUserInfo: '__USER_REGISTER_INFO__',
  //登录成功后的跳转页面缓存名
  redirectKey: '__USER_TO_PATH__',
  //异常oauth登录计次(如果回来的微信头像 昵称为null 则进行+1计次 否则执行清除本缓存)
  oauthExceptionMaxTimes: 3,
  oauthExceptionTimesName: '__USER_OAUTH_EXCEPTION_TIMES__',

  rechargeShopIdCacheName: '__RECHARGE_SHOP_ID__',
  refereeCodeName: '__REFEREE_CODE__',
  refereeShopIdName: '__REFEREE_SHOP_ID__',

}



// WEBPACK FOOTER //
// ./src/config/config.js